import { single, multiple } from "./bundle";
import { one, many, } from "./association";
const targets2Assocs = (g, targets) => Object.fromEntries(Object.entries(targets).map(([key, value]) => [key, g(() => value)]));
/**
 * Used when the the sonic relationship has the following nature `x -> y`
 *
 * Example:
 *
 * ```typescript
 * const relationships = { link: single2One(() => Link.Resource.target) }
 * ```
 *
 * @param target A target that constitutes of the data type you want to point to
 */
const single2One = (target) => single(one(target));
/**
 * Used when the the sonic relationship has the following nature `x -> y[]`
 *
 * Example:
 *
 * ```typescript
 * const relationships = { links: single2Many(() => Link.Resource.target) }
 * ```
 *
 * @param target A target that constitutes of the data type you want to point to
 */
const single2Many = (target) => single(many(target));
/**
 * Used when the the sonic relationship has the following nature `x -> y | z | ...`
 *
 * Example:
 *
 * ```typescript
 * // content can point to either a link or a video
 * const _possibleContent = { link: Link.Resource.target, video: Video.Resource.target }
 * const relationships = { content: multiple2One(_possibleContent) }
 * ```
 *
 * @param targets An object of targets with a namspaced `key` where `value`
 * constitutes of the data type you want to point to
 */
const multiple2One = (targets) => multiple(targets2Assocs(one, targets));
/**
 * Used when the the sonic relationship has the following nature `x -> y[] | z[] | ...`
 * DISCLAIMER! There is currently no case of this being used in sonic. Please use carefully.
 * If you dont know if you need this function, you probably dont need it.
 *
 * Example:
 *
 * ```typescript
 * // content can point to either a link or a video
 * const _possibleContent = { links: Link.Resource.target, videos: Video.Resource.target }
 * const relationships = { content: multiple2Many(_possibleContent) }
 * ```
 *
 * @param targets An object of targets with a namspaced `key` where `value`
 * constitutes of the data type you want to point to
 */
const multiple2Many = (targets) => multiple(targets2Assocs(many, targets));
/**
 * Allows for a proper relationship object from a object of targets
 *
 * Example:
 *
 * ```typescript
 * const relationships = targets2Relationships({
 *   link: Link.Resource.target,
 *   video: Video.Resource.target
 * })
 * ```
 *
 * @param targets An object of targets with a namspaced `key` where `value`
 * constitutes of the data type you want to point to
 */
const targets2Relationships = (targets) => Object.fromEntries(Object.entries(targets).map(([key, value]) => [
    key,
    single2One(() => value),
]));
export { single2One, single2Many, multiple2One, multiple2Many, targets2Relationships, };

